export const API_SCOPE = [
    "agent:read",
    "agent:write",
    "conversation:read",
    "recording:read",
    "campaign:write",
    "credit:spend",
    "order:read",
    "order:write",
    "conversation:dial",
];
export const WEBHOOK_EVENT_KIND = [
    "call.started",
    "call.ended",
    "transcript.ready",
    "order.confirmed",
    "thread.started",
    "thread.ended",
    "booking.created",
    "campaign.finished",
    "agent.published",
];
//# sourceMappingURL=developer.js.map